<template>
  <img v-if="maintainImg" :src="maintainImg" />
  <Spinner v-else bgc="#f6f6f6" />
</template>

<script>
import Spinner from '@/components/shared/Spinner.vue'

export default {
  components: {
    Spinner,
  },
  data() {
    return { maintainImg: '' }
  },
  mounted() {
    this.getMaintainImg()
  },
  methods: {
    getMaintainImg() {
      const maintainInfo = JSON.parse(localStorage.getItem('maintenanceInfo'))
      if (maintainInfo) {
        this.maintainImg = maintainInfo.imagePath
      }
    },
  },
}
</script>

<style scoped>
img {
  width: 100%;
}
</style>
